import { Link, Text } from "@certn/cascadia-react";
import { Trans } from "react-i18next";

interface Props {
  privacyPolicyUrl: string;
}

export function HelpPrivacyConsent(props: Props) {
  return (
    <Trans>
      <Text color="text-weak">
        By clicking 'Submit', you agree to be contacted by Certn for the
        purposes of providing further information. You can withdraw your consent
        at any time by contacting Certn’s Privacy Officer at +1 (844) 987-0690
        or{" "}
        <Link
          testID="privacy-email"
          target="_blank"
          textStyle="global/body-secondary"
          textColor="text-weak"
          href="mailto: privacy@certn.co"
        >
          privacy@certn.co
        </Link>
        . Further information regarding the collection, use, disclosure, or
        storage of your Personal Information can be found in our{" "}
        <Link
          testID="privacy-policy"
          target="_blank"
          textStyle="global/body-secondary"
          textColor="text-weak"
          href={props.privacyPolicyUrl}
        >
          Privacy Policy
        </Link>
        .
      </Text>
    </Trans>
  );
}
